var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.24,
    y: 56.889,
    style: {
      fill: "#4173CD"
    },
    width: 317.76,
    height: 56.889
  }), /*#__PURE__*/React.createElement("rect", {
    y: 113.78,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 56.889
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.24,
    y: 170.67,
    style: {
      fill: "#4173CD"
    },
    width: 317.76,
    height: 56.889
  }), /*#__PURE__*/React.createElement("rect", {
    y: 227.56,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 56.889
  }), /*#__PURE__*/React.createElement("rect", {
    y: 284.44,
    style: {
      fill: "#4173CD"
    },
    width: 512,
    height: 56.889
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.33,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 56.889
  }), /*#__PURE__*/React.createElement("rect", {
    y: 398.22,
    style: {
      fill: "#4173CD"
    },
    width: 512,
    height: 56.889
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "97.646,35.665 120.187,139.961 155.456,125.352 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "97.646,35.665 137.821,132.656 120.187,139.961 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "185.301,247.282 162.761,142.987 127.491,157.596 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "185.301,247.282 145.126,150.291 162.761,142.987 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "247.282,97.646 142.987,120.187 157.596,155.456 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "247.282,97.646 150.291,137.821 142.987,120.187 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "35.665,185.301 139.961,162.761 125.352,127.491 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "35.665,185.301 132.656,145.126 139.961,162.761 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "185.301,35.665 127.491,125.352 162.761,139.961 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "185.301,35.665 145.126,132.656 127.491,125.352 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "97.646,247.282 155.456,157.596 120.187,142.987 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "97.646,247.282 137.821,150.291 155.456,157.596 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "247.282,185.301 157.596,127.491 142.987,162.761 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "247.282,185.301 150.291,145.126 157.596,127.491 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "35.665,97.646 125.352,155.456 139.961,120.187 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "35.665,97.646 132.656,137.821 125.352,155.456 "
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F5F5F5"
    },
    width: 283,
    height: 284
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "141.474,26.947 122.386,131.93 160.561,131.93 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "141.474,26.947 141.474,131.93 122.386,131.93 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "141.474,256 160.561,151.018 122.386,151.018 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "141.474,256 141.474,151.018 160.561,151.018 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "256,141.474 151.018,122.386 151.018,160.561 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "256,141.474 151.018,141.474 151.018,122.386 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "26.947,141.474 131.93,160.561 131.93,122.386 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "26.947,141.474 131.93,141.474 131.93,160.561 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "222.456,60.491 134.725,121.228 161.719,148.222 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "222.456,60.491 148.222,134.725 134.725,121.228 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "60.491,222.456 148.222,161.719 121.228,134.725 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "60.491,222.456 134.725,148.222 148.222,161.719 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "222.456,222.456 161.719,134.725 134.725,161.719 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "222.456,222.456 148.222,148.222 161.719,134.725 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "60.491,60.491 121.228,148.222 148.222,121.228 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "60.491,60.491 134.725,134.725 121.228,148.222 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 141.47,
    cy: 141.47,
    r: 38.17
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUy);
export default __webpack_public_path__ + "static/media/UY.815ca32790238ae20b93effcb3f060a1.svg";
export { ForwardRef as ReactComponent };